import {useEffect} from "react";
import {useSelector} from "react-redux";

import i18n from "./i18n";

export default function LanguageSync() {
	const lang = useSelector((s) => s.language);

	useEffect(() => {
		if (i18n.language !== lang) {
			i18n.changeLanguage(lang);
		}
	}, [lang]);

	return null;
}
